(function(app) {

    app.config([
        "$stateProvider", function($stateProvider) {
            $stateProvider.state("Sso",
            {
                url: "/Sso?{accesstoken}&{onbehalfofauthuserid}&{fasttrack}&{expiration}",
                component: "sso"
            });
        }
    ]);

    app.component("sso",
    {
        controller: ssoController
    });

    ssoController.$inject = ["$stateParams", "$state", "userApi", "permissionService", "complianceHubApiGateway", "$q"];

    function ssoController($stateParams, $state, userApi, permissionService, complianceHubApiGateway, $q) {
        var isFastTrack = $stateParams.fasttrack ? true : false;

        var headers = { "Authorization": "Bearer " + $stateParams.accesstoken };
        if ($stateParams.onbehalfofauthuserid)
            //headers["X-On-Behalf-Of"] = $stateParams.onbehalfofauthuserid;
            headers["X-On-Behalf-Of-Fig-Auth"] = $stateParams.onbehalfofauthuserid;

        complianceHubApiGateway.post("/Login/SwitchAuth", {}, { headers: headers }).then(function () {

            permissionService.removeStoredPermissions();
            permissionService.removeStoredOnBehalfOfUserId();

            var promises = [];
            if ($stateParams.onbehalfofauthuserid) {
                promises.push(userApi.getUserByAuthId($stateParams.onbehalfofauthuserid).then(function (user) {
                    permissionService.setOnBehalfOfUserId(user.Id);
                }));
            }
            promises.push(userApi.getCurrentUserPermissions().then(function (permissions) {
                permissionService.setPermissions(permissions);
            }));

            return $q.all(promises).then(function () {
                if (isFastTrack) {
                    $state.go("FastTrack.Initiate");
                } else {
                    $state.go("Home.Dashboard");
                }
            });
        });
    }
})(window.app); //jshint ignore:line